import * as yup from 'yup';

export const validateCity = yup
  .string()
  .nullable()
  .trim()
  .required('Ort krävs');
